<!-- <template>
  <div class="backdrop" @click.self="$emit('close')">
      <button class="close" role="button" @click="$emit('close')"> &times;</button>
    <div class="content">
      <div class="text" dir="rtl">
        <span>با سلام</span>
        اگر خواستی از این وبسایت با هر مبلغی حمایت کن.
      </div>
      <div class="cart">
        <span>6393-4610-4933-1917</span>
        <span>احسان ملک</span>
      </div>
      <button @click.prevent="$emit('close')">بستن</button>
    </div>
  </div>
</template> -->

<script>
export default {
  data() {
    return {}
  },
  methods: {
    copyText(text) {

    }
  }
}
</script>

<style lang="scss" scoped>
.backdrop {
  z-index: 99;
  padding: 20px;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .close
  {
    color: white;
    font-size: 30px;
    font-weight: bold;
    position: absolute;
    top: 20px;
    right: 25px;
  }
  .content {
    position: absolute;
    background: #fff;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 40px;
    margin: 20px;
    .text {
      text-align: start;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 5px;
    }

    div > span {
      display: block;
    }

    .cart {
      width: 100%;
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span{
        font-weight: bold;
      }
    }
  }

  button:not(.close) {
    padding: 5px 18px;
    cursor: pointer;
    background: #dd0000;
    margin-top: 20px;
    color: white;
    border-radius: 5px
  }
}
@media screen and (max-width: 400px) {
  .content{
    padding: 25px !important;
  }
  .cart{
    display: flex;
    flex-direction: column;
  }
}
</style>